import * as React from "react";
import { Button } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import CreateReportDialog from "../../components/dialogs/createReport";
import { connect, Dispatch } from "react-redux";
import { GlobalState } from "../../store";
import * as actions from "../../store/cases/actions";
interface Props {
  fetchReports: () => void;
}
interface State {}
class AddReportButton extends React.Component<Props, State> {
  state = {
    showNewCase: false
  };
  render() {
    return (
      <React.Fragment>
        <CreateReportDialog
          open={this.state.showNewCase}
          onCreate={caseID => {
            this.props.fetchReports();
            // window.location.href = "/case/" + caseID;
            this.setState({ showNewCase: false });
          }}
          onClose={() => this.setState({ showNewCase: false })}
        />
        <Button
          onClick={() => this.setState({ showNewCase: true })}
          variant="fab"
          color="primary"
          aria-label="Add"
          style={{
            position: "absolute",
            bottom: 32,
            right: 32
          }}
        >
          <AddIcon />
        </Button>
      </React.Fragment>
    );
  }
}
export default connect(
  (state: GlobalState, own: any) => ({}),
  dispatch => ({
    fetchReports: (): any => dispatch(actions.fetchReports())
  })
)(AddReportButton);



// WEBPACK FOOTER //
// ./src/pages/reports/addReportButton.tsx